module.exports = "#ifdef USE_TRIPLANAR\n  varying vec3 OPosition;\n  varying vec3 ONormal;\n#endif\n";